'use client';
import Link from 'next/link';

import { ImageComponent } from '../../../../components/Image';
import { AnalyticsEventName } from '@/api/analytics';
import { isIos } from '@/helpers/common';
import { useAnalytics } from '@/hooks/analytics';
import { useNavigation } from '@/hooks/navigation';
import { useCMSConfig } from '@/modules/common';
import { useCommonStore } from '@/store';

interface LinkProps {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

export const IOSLink = ({ onClick }: LinkProps) => {
  const { generateLink } = useNavigation();
  return (
    <Link
      href={generateLink('/mobile-app')}
      className="button"
      aria-label="App Store link"
      onClick={onClick}
    >
      <ImageComponent
        src="/app/ios.webp"
        alt="App Store link"
        width={135}
        height={40}
      />
    </Link>
  );
};

export const ANDROIDLink = ({ onClick }: LinkProps) => {
  const { generateLink } = useNavigation();
  return (
    <Link
      href={generateLink('/mobile-app')}
      className="button"
      aria-label="Google Play link"
      onClick={onClick}
    >
      <ImageComponent
        src="/app/android.webp"
        alt="Google Play link"
        width={135}
        height={40}
      />
    </Link>
  );
};

export const AppLinks = () => {
  const isMobileDevice = useCommonStore.use.isMobileDevice();
  const { mobileAppCMS } = useCMSConfig();

  const { sendEventToAnalytics } = useAnalytics();

  const handleClickAndroid = () => {
    sendEventToAnalytics({
      name: AnalyticsEventName.FOOTER__ANDROID_APP_ICON__LINK__CLICK,
    });
  };

  if (!mobileAppCMS) return null;

  if (isMobileDevice) {
    if (!isIos() && mobileAppCMS.showAndroid) {
      return <ANDROIDLink onClick={handleClickAndroid} />;
    }
    return null;
  }

  return (
    <>
      {mobileAppCMS.showAndroid && <ANDROIDLink onClick={handleClickAndroid} />}
    </>
  );
};
